// Central API CONFIGURATION
// For buliding fe static files image on TST/PROD, the API URL is /api, which is proxied to the backend by nginx. This allows the same frontend image to be used in both TST and PROD without modification.
// Locally you can set REACT_APP_API_URL in .env file to point to your local backend, e.g. http://localhost:5000/api

const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

export default API_BASE_URL;
